(() => {
  const dialog = document.getElementById('pcp-exit-capture');
  const mobile = document.getElementById('pcp-mobile-capture');
  if (!dialog || !mobile || window.Shopify?.designMode) return;
  const key = 'pcp_capture_dismissed_until';
  const start = Date.now();
  let shown = false, focusedBefore;
  let blocked = false;
  try { blocked = Number(localStorage.getItem(key)) > Date.now(); } catch (_) {}
  const quiet = () => {
    blocked = true;
    try { localStorage.setItem(key, String(Date.now() + 7 * 86400000)); } catch (_) {}
  };
  const emit = name => {
    // Never expose an email, form values, URL query, or case information to analytics.
    if (window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() !== true) return;
    document.dispatchEvent(new CustomEvent('pcp:funnel-event', {detail: {
      event: name, event_id: globalThis.crypto?.randomUUID?.() || String(Date.now()),
      page_type: document.body.dataset.pcpTemplate || 'unknown'
    }}));
  };
  const success = document.querySelector('[data-pcp-signup-success]');
  if (success) {
    quiet();
    document.addEventListener('DOMContentLoaded', () => {
      try {
        if (sessionStorage.getItem('pcp_signup_pending') === '1') {
          sessionStorage.removeItem('pcp_signup_pending');
          emit('email_signup_received');
        }
      } catch (_) {}
    }, {once:true});
  }
  document.querySelectorAll('.pcp-capture-form').forEach(form => {
    form.addEventListener('submit', event => {
      if (!form.checkValidity()) { event.preventDefault(); form.reportValidity(); return; }
      quiet();
      try { sessionStorage.setItem('pcp_signup_pending', '1'); } catch (_) {}
      emit('email_signup_submitted');
    });
  });
  const close = () => { dialog.close(); mobile.hidden = true; quiet(); focusedBefore?.focus?.(); };
  dialog.querySelectorAll('[data-pcp-capture-close]').forEach(button => button.addEventListener('click', close));
  dialog.addEventListener('cancel', () => { quiet(); focusedBefore?.focus?.(); });
  dialog.addEventListener('click', event => { if (event.target === dialog) {
    const r=dialog.getBoundingClientRect();
    if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)close();
  }});
  mobile.querySelector('[data-pcp-mobile-close]').addEventListener('click', close);
  mobile.querySelector('a').addEventListener('click', () => {
    mobile.hidden=true; quiet(); document.getElementById('pcp-inline-signup-email')?.focus({preventScroll:true});
  });
  document.addEventListener('focusin', event => { if (event.target.matches('input,textarea,select')) mobile.hidden=true; });
  const eligible = () => !blocked && !shown && !document.querySelector('dialog[open]') && !document.activeElement?.matches('input,textarea,select');
  document.addEventListener('mouseout', event => {
    if (event.relatedTarget !== null || event.clientY > 0 || Date.now()-start < 25000 || !matchMedia('(min-width:750px) and (pointer:fine)').matches || !eligible()) return;
    shown=true; quiet(); focusedBefore=document.activeElement; dialog.showModal(); emit('email_capture_view');
  });
  const mobileInvite = () => {
    if (!matchMedia('(max-width:749px)').matches || Date.now()-start<45000 || !eligible()) return;
    const available=document.documentElement.scrollHeight-innerHeight;
    if(available<=0 || scrollY/available<.5) return;
    shown=true;quiet();mobile.hidden=false;emit('email_capture_view');
  };
  document.addEventListener('scroll',mobileInvite,{passive:true});
  setTimeout(mobileInvite,45000);
})();
